import React, { useEffect, Fragment, useState, useRef } from "react";
import Breadcrumb from "../../../../components/common/breadcrumb";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { showToast } from "../../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import {
  GetNursingStationById,
  UpdateNursingStation
} from "../../../../api/ipd/nursingStationAPI";
import useKeyboardSubmit from "../../../../hooks/useKeyboardSubmit";
import useEnterNavigation from "../../../../hooks/useEnterNavigation";

// Validation schema using Yup
const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  floor: yup.string().required("Floor is required")
});

const EditNursingStation = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { id } = useParams();

  const { register, handleSubmit, setValue, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  const fetchData = async () => {
    try {
      const response = await GetNursingStationById(id); // Make sure login function returns token

      if (response.success) {
        setValue("name", response.data.name);
        setValue("floor", response.data.floor);
      } else {
        // setError(response.message);
        showToast("error", response.message);
      }
    } catch (error) {
      // setError(error); // Handle login errors
      showToast("error", error);
    }
  };

  // Fetch existing data
  useEffect(
    () => {
      if (id) {
        fetchData();
      }
    },
    [id, setValue]
  );

  const onSubmit = async data => {
    try {
      dispatch({ type: "LOADER_START" });

      const response = await UpdateNursingStation(id, data);
      if (response.success) {
        showToast("success", response.message);
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  const formRef = useRef(null);
  useKeyboardSubmit(handleSubmit, onSubmit);
  useEnterNavigation(formRef);

  return (
    <Fragment>
      <Breadcrumb parent="Nursing Station" title="Add Nursing Station" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h5>Add Nursing Station</h5>
                  <Link to={`/ipd/master/nursing-station/list`}>
                    <button className="btn btn-primary" id="list">
                      List Nursing Station
                    </button>
                    <UncontrolledTooltip placement="top" target="list">
                      List Nursing Station
                    </UncontrolledTooltip>
                  </Link>
                </div>
              </div>
              <form
                ref={formRef}
                className="form theme-form"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="name">Station Name *</label>
                        <input
                          className="form-control"
                          id="name"
                          type="text"
                          placeholder="Station Name"
                          {...register("name")}
                        />
                        {errors.name &&
                          <p className="text-danger">
                            {errors.name.message}
                          </p>}
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="name">Floor *</label>
                        <input
                          className="form-control"
                          id="name"
                          type="number"
                          placeholder="Floor"
                          {...register("floor")}
                        />
                        {errors.floor &&
                          <p className="text-danger">
                            {errors.floor.message}
                          </p>}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer text-end">
                  <button className="btn btn-primary me-2" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default EditNursingStation;
